import React from 'react';
import { Tag } from 'antd';
import { ALIMTALK_SEND_STATUS_LABEL, ALIMTALK_SEND_STATUS_TAG_COLOR } from '../../constants';
import { ALIMTALK_SEND_STATUS, AlimtalkSendStatus } from '../../types';

interface Props {
  status: AlimtalkSendStatus;
  isTest?: boolean;
}

/**
 *  알림톡 발송 상태 뱃지
 *  - 프론트가 모르는 status(백엔드 신규 값)는 빈 태그 대신 원문 문자열을 그대로 보여준다.
 *  - TEST_COMPLETED 는 라벨("테스트 발송 완료")에 이미 테스트가 드러나므로 테스트 태그를 덧붙이지 않는다.
 */
const AlimtalkSendStatusTag = ({ status, isTest }: Props): JSX.Element => {
  const showTestTag = isTest && status !== ALIMTALK_SEND_STATUS.TEST_COMPLETED;
  return (
    <>
      <Tag color={ALIMTALK_SEND_STATUS_TAG_COLOR[status] ?? 'default'} style={{ margin: 0 }}>
        {ALIMTALK_SEND_STATUS_LABEL[status] ?? status}
      </Tag>
      {showTestTag ? (
        <Tag color="gold" style={{ marginInlineStart: 4 }}>
          테스트
        </Tag>
      ) : null}
    </>
  );
};

export default AlimtalkSendStatusTag;
